import classNames from 'classnames';
import { Children, cloneElement, createElement, isValidElement } from 'react';

var Group = function (props) {
    var className = props.className, _a = props.orientation, orientation = _a === void 0 ? 'horizontal' : _a, component = props.component;
    var Wrapper = component || 'div';
    var children = Children.map(props.children, function (child) {
        return isValidElement(child) && typeof child.type !== 'string'
            ? cloneElement(child, { className: classNames(child.props.className, 'RUIGroup_Element') })
            : child;
    });
    return (createElement(Wrapper, { className: classNames('RUIGroup', "RUIGroup-" + orientation, className) }, children));
};

export { Group };
//# sourceMappingURL=Group.js.map



// WEBPACK FOOTER //
// /static/node_modules/@ridi/rsg/components/dist/Group.js